/** A table label as typed or imported: a bare number or "table 3" / "TABLE #3" becomes "Table 3"; other names only get tidy spacing. */
export function canonTable(s: string | undefined): string {
  const t = (s ?? "").replace(/\s+/g, " ").trim();
  const m = /^(?:table\s*#?\s*)?#?(\d{1,4})$/i.exec(t);
  return m ? `Table ${Number(m[1])}` : t;
}
